import Link from 'next/link';
import { useRouter } from 'next/router';

import { H6 } from '@common/headline';

import { CategoryLinkType } from '@nextTypes/guides';

type Props = {
  link: CategoryLinkType;
  isSubcategoryLink: boolean;
};

const baseClasses = 'inline-block px-1 mx-4';
const additionalActiveClasses = 'border-b-2 border-blue';

const CategoryLink = ({ link, isSubcategoryLink }: Props): JSX.Element => {
  const { asPath } = useRouter();

  const yMarginClass = isSubcategoryLink ? 'my-0' : 'my-7';

  const allClasses = `${baseClasses} ${yMarginClass}`;

  return (
    <Link
      href={link.href}
      prefetch={false}
      className={
        link.isSelected === true ||
        link.isParent === true ||
        (asPath.includes(link.href) && link.isSelected !== false)
          ? `${allClasses} ${additionalActiveClasses}`
          : allClasses
      }
    >
      <H6>{link.title}</H6>
    </Link>
  );
};

CategoryLink.defaultProps = {
  isSubcategoryLink: false,
};

export default CategoryLink;
